import { initializeApp } from "firebase/app";
import { getAuth } from "firebase/auth";
import { getFirestore } from "firebase/firestore";
import { getStorage } from "firebase/storage";

const firebaseConfig = {
  apiKey:
    process.env.REACT_APP_FIREBASE_API_KEY ||
    "AIzaSyCdMcdkKqCAPHXTLvtTnPvSVcqxGsjDOqk",
  authDomain:
    process.env.REACT_APP_FIREBASE_AUTH_DOMAIN || "presti-ya.firebaseapp.com",
  projectId: process.env.REACT_APP_FIREBASE_PROJECT_ID || "presti-ya",
  storageBucket:
    process.env.REACT_APP_FIREBASE_STORAGE_BUCKET ||
    "presti-ya.firebasestorage.app",
  messagingSenderId:
    process.env.REACT_APP_FIREBASE_MESSAGING_SENDER_ID || "1068774953588",
  appId:
    process.env.REACT_APP_FIREBASE_APP_ID ||
    "1:1068774953588:web:9ff82924025caa030d7721",
  measurementId:
    process.env.REACT_APP_FIREBASE_MEASUREMENT_ID || "G-39RZC11P6D",
};

const appService = initializeApp(firebaseConfig, "service");

const authService = getAuth(appService);
const firestoreService = getFirestore(appService);
const storageService = getStorage(appService);

export { authService, firestoreService, storageService };
